import { ILookup, IPaginationResponse } from '../../../common';
import { ICreateCustomerProfileResponse, ICustomerProfileBaseResponse, ICustomerProfileResponse, IPublicOffStreetReservationResponse, IReservationListResponse, IReservationResponse, ICustomerInvoiceListResponse } from '../dtos';
import { IOnStreetReservationResponse } from '../../../order-management';
import { IInvoiceResponse } from '../../../financial-management/invoices';

const customerProfilesResponse: IPaginationResponse<ICustomerProfileResponse> = {
  items: [
    {
      firstName: 'Ayman',
      lastName: 'Ahmed',
      email: 'ahmed@makani.com',
      phoneNumber: {
        countryCode: '+20',
        number: '1201538502'
      },
      userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
      isMobileNumberVerified: true,
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-15T16:21:59.9437374',
      modifiedOnUtc: '2025-02-15T16:22:25.8153649',
      createdById: 'caed2a61-1733-4f43-8118-abaae3362da1',
      modifiedById: '7e3787df-23c7-434d-9df8-b7f8bc7755ec',
      id: '2716369a-08df-491b-a1f2-ba0eb489b471'
    },
    {
      firstName: 'Ayman',
      lastName: 'Ahmed',
      email: 'ahmed@makani.com',
      phoneNumber: {
        countryCode: '+20',
        number: '1201538503'
      },
      userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
      isMobileNumberVerified: true,
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-15T16:20:23.416632',
      modifiedOnUtc: '2025-02-15T16:21:35.7517411',
      createdById: '7e3787df-23c7-434d-9df8-b7f8bc7755ec',
      modifiedById: 'caed2a61-1733-4f43-8118-abaae3362da1',
      id: '461edef8-54cc-4feb-a221-07e854add3cb'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const customerProfileResponse: ICustomerProfileResponse = {
  firstName: 'Ayman',
  lastName: 'Ahmed',
  email: 'ahmed@makani.com',
  phoneNumber: {
    countryCode: '+20',
    number: '1201538502'
  },
  userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
  isMobileNumberVerified: true,
  isActive: true,
  status: 'Active',
  createdOnUtc: '2025-02-14T19:05:33.879256',
  modifiedOnUtc: '2025-02-14T19:06:00.10543',
  createdById: '531fadbb-7cbf-4f56-9c03-dced338afa5d',
  modifiedById: 'b20d1737-b5a2-4e00-ba87-f205fec36596',
  id: '41328966-548b-4d15-919e-15869e7038e3'
};

const createCustomerProfileResponse: ICreateCustomerProfileResponse = {
  firstName: 'Ayman',
  lastName: 'Ahmed',
  email: 'ahmed@makani.com',
  phoneNumber: {
    countryCode: '+20',
    number: '1201538502'
  },
  accountId: '531fadbb-7cbf-4f56-9c03-dced338afa5d',
  userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
  isMobileNumberVerified: true,
  isActive: true,
  status: 'Active',
  createdOnUtc: '2025-02-14T19:05:33.879256',
  modifiedOnUtc: '2025-02-14T19:06:00.10543',
  createdById: '531fadbb-7cbf-4f56-9c03-dced338afa5d',
  modifiedById: 'b20d1737-b5a2-4e00-ba87-f205fec36596',
  id: '41328966-548b-4d15-919e-15869e7038e3'
};

const customerEligibleAccountsResponse: IPaginationResponse<ILookup<string>> = {
  items: [
    {
      englishName: 'teac',
      id: 'dd73f266-9fdc-4234-be88-828e7f42cabb'
    },
    {
      englishName: 'team',
      id: '9d1fad93-f2da-446b-816a-d08530bfdfbc'
    },
    {
      englishName: 'tean',
      id: 'ea8ad59a-b779-4157-a230-1aa8f6404c7c'
    }
  ],
  paginationMetadata: {
    totalItemCount: 3,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const customerProfilesBaseResponse: IPaginationResponse<ICustomerProfileBaseResponse> = {
  items: [
    {
      firstName: 'Ayman',
      lastName: 'Ahmed',
      email: 'ahmed@makani.com',
      phoneNumber: {
        countryCode: '+20',
        number: '1201538502'
      },
      userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
      isMobileNumberVerified: true,
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-15T16:21:59.9437374',
      modifiedOnUtc: '2025-02-15T16:22:25.8153649',
      createdById: 'caed2a61-1733-4f43-8118-abaae3362da1',
      modifiedById: '7e3787df-23c7-434d-9df8-b7f8bc7755ec',
      id: '2716369a-08df-491b-a1f2-ba0eb489b471'
    },
    {
      firstName: 'Ayman',
      lastName: 'Ahmed',
      email: 'ahmed@makani.com',
      phoneNumber: {
        countryCode: '+20',
        number: '1201538503'
      },
      userId: 'caed2a61-1733-4f43-8118-abaae3362da1',
      isMobileNumberVerified: true,
      isActive: true,
      status: 'Active',
      createdOnUtc: '2025-02-15T16:20:23.416632',
      modifiedOnUtc: '2025-02-15T16:21:35.7517411',
      createdById: '7e3787df-23c7-434d-9df8-b7f8bc7755ec',
      modifiedById: 'caed2a61-1733-4f43-8118-abaae3362da1',
      id: '461edef8-54cc-4feb-a221-07e854add3cb'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const myOnStreetReservationResponse: IOnStreetReservationResponse = {
  id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  createdOnUtc: '2025-03-20T10:00:00Z',
  modifiedOnUtc: '2025-03-20T10:00:00Z',
  createdById: 'caed2a61-1733-4f43-8118-abaae3362da1',
  modifiedById: 'caed2a61-1733-4f43-8118-abaae3362da1',
  parkingArea: { id: 'c3d4e5f6-a7b8-9012-cdef-345678901234', englishName: 'Zone A', arabicName: 'المنطقة أ' },
  vehicle: {
    id: 'd9ce027d-fc7a-4545-86aa-c47f499c6b27',
    licensePlate: {
      plateLetters: 'AAb',
      plateDigits: '112',
      licensePlateType: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Private',
        arabicName: 'خاص'
      }
    },
    productionYear: 2022,
    accessStatus: 'Active',
    vehicleType: 'Sedan',
    make: {
      id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
      englishName: 'Toyota',
      arabicName: 'تويوتا'
    },
    model: {
      id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
      englishName: 'Camry',
      arabicName: 'كامري'
    }
  },
  servicePrice: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول',
    hourRate: { amount: 10, currency: 'SAR' }
  },
  pricing: {
    subtotal: { amount: 40.0, currency: 'SAR' },
    discount: {
      discountValue: { amount: 0, currency: 'SAR' },
      discountSource: 'None'
    },
    vat: {
      vatAmount: { amount: 6.0, currency: 'SAR' },
      vatPercentage: 15
    },
    total: { amount: 46.0, currency: 'SAR' }
  },
  status: 'Active',
  startTime: '2025-03-20T10:00:00Z',
  endTime: '2025-03-20T12:00:00Z',
  isIntegrationSource: false,
  totalHours: 2,
  remainingHours: 1
};

const myOnStreetReservationsResponse: IPaginationResponse<IOnStreetReservationResponse> = {
  items: [myOnStreetReservationResponse],
  paginationMetadata: {
    totalItemCount: 1,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const myInvoiceByOrderResponse: IInvoiceResponse = {
  id: 'f6a7b8c9-d0e1-2345-f678-901234567890',
  createdOnUtc: '2025-03-20T12:00:00Z',
  modifiedOnUtc: '2025-03-20T12:00:00Z',
  createdById: 'caed2a61-1733-4f43-8118-abaae3362da1',
  modifiedById: 'caed2a61-1733-4f43-8118-abaae3362da1',
  customer: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Ayman Ahmed',
    type: 'Individual',
    subscriptionType: '',
    phoneNumber: '+201201538502'
  },
  client: { id: '3fa85f64-5717-4562-b3fc-2c963f66afa6', englishName: 'Makani', arabicName: 'مكاني' },
  project: { id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901', englishName: 'Main Project', arabicName: 'المشروع الرئيسي' },
  orderId: 'e5f6a7b8-c9d0-1234-ef56-789012345678',
  invoiceNumber: 'INV-2025-001',
  type: 'Standard',
  source: 'OnStreetReservation',
  paymentMethod: 'Wallet',
  vatPercentage: 15,
  status: 'Paid',
  totalPrice: { amount: 50.0, currency: 'USD' },
  invoiceLines: [],
  invoiceHistories: []
};

const reservationResponse: IReservationResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  client: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  project: {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    englishName: 'Main Center',
    arabicName: 'المركز الرئيسي'
  },
  customer: {
    id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    englishName: 'John Doe',
    type: 'Customer',
    subscriptionType: 'B2C'
  },
  parkingArea: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  servicePrice: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  invoice: {
    id: '550e8400-e29b-41d4-a716-446655440000',
    createdOnUtc: '2025-02-25T10:00:00Z',
    modifiedOnUtc: '2025-02-25T11:00:00Z',
    createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
    modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
    pricing: {
      total: {
        currency: 'SAR',
        amount: 100
      },
      subtotal: {
        currency: 'SAR',
        amount: 100
      },
      vat: {
        vatAmount: {
          currency: 'SAR',
          amount: 100
        },
        vatPercentage: 10
      },
      discount: {
        discountValue: {
          currency: 'SAR',
          amount: 100
        },
        discountSource: 'Discount',
        discountReferenceId: '1234567890'
      }
    },
    invoiceNumber: 'INV-250903'
  },
  vehicles: [
    {
      licensePlate: {
        plateLetters: 'AAb',
        plateDigits: '112',
        licensePlateType: {
          id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
          englishName: 'Provider One',
          arabicName: 'العميل الاول'
        }
      },
      make: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      model: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      id: 'd9ce027d-fc7a-4545-86aa-c47f499c6b27',
      autoIncrementalId: 0
    }
  ],
  isIntegrationSource: true,
  isSettled: false,
  status: 'AboutToExpire',
  orderId: '3d5672aa-3674-4a24-9bf4-be39cd83e210',
  startTime: '2025-08-09T10:47:19.589',
  endTime: '2025-08-19T10:47:19.589',
  code: 'code1',
  pricing: {
    total: {
      currency: 'SAR',
      amount: 100
    },
    subtotal: {
      currency: 'SAR',
      amount: 100
    },
    vat: {
      vatAmount: {
        currency: 'SAR',
        amount: 100
      },
      vatPercentage: 10
    },
    discount: {
      discountValue: {
        currency: 'SAR',
        amount: 100
      },
      discountSource: 'Discount',
      discountReferenceId: '1234567890'
    }
  }
};

const publicOffStreetReservationResponse: IPublicOffStreetReservationResponse = {
  id: '550e8400-e29b-41d4-a716-446655440000',
  createdOnUtc: '2025-02-25T10:00:00Z',
  modifiedOnUtc: '2025-02-25T11:00:00Z',
  createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
  modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
  customer: {
    type: 'Customer',
  },
  parkingArea: {
    id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
    englishName: 'Provider One',
    arabicName: 'العميل الاول'
  },
  invoice: {
    id: '550e8400-e29b-41d4-a716-446655440000',
    invoiceNumber: 'INV-250903'
  },
  isIntegrationSource: true,
  isSettled: true,
  status: 'Active',
  orderId: '3d5672aa-3674-4a24-9bf4-be39cd83e210',
  startTime: '2025-08-09T10:47:19.589',
  endTime: '2025-08-19T10:47:19.589',
  code: 'code1',
  pricing: {
    total: {
      currency: 'SAR',
      amount: 100
    },
    subtotal: {
      currency: 'SAR',
      amount: 100
    },
    vat: {
      vatAmount: {
        currency: 'SAR',
        amount: 100
      },
      vatPercentage: 10
    },
    discount: {
      discountValue: {
        currency: 'SAR',
        amount: 100
      },
      discountSource: 'Discount',
      discountReferenceId: '1234567890'
    }
  }
};

const reservationsResponse: IPaginationResponse<IReservationListResponse> = {
  items: [
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      parkingArea: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      servicePrice: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي',
        hourRate: { amount: 10, currency: 'SAR' }
      },
      vehicles: [
        {
          licensePlate: {
            plateLetters: 'AAb',
            plateDigits: '112',
            licensePlateType: {
              id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
              englishName: 'Provider One',
              arabicName: 'العميل الاول'
            }
          },
          make: {
            id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
            englishName: 'Provider One',
            arabicName: 'العميل الاول'
          },
          model: {
            id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
            englishName: 'Provider One',
            arabicName: 'العميل الاول'
          },
          id: 'd9ce027d-fc7a-4545-86aa-c47f499c6b27',
          autoIncrementalId: 0
        }
      ],
      isIntegrationSource: true,
      isSettled: true,
      status: 'Active',
      orderId: '3d5672aa-3674-4a24-9bf4-be39cd83e210',
      startTime: '2025-08-09T10:47:19.589',
      endTime: '2025-08-19T10:47:19.589',
      code: 'code1',
      pricing: {
        total: {
          currency: 'SAR',
          amount: 100
        },
        subtotal: {
          currency: 'SAR',
          amount: 100
        },
        vat: {
          vatAmount: {
            currency: 'SAR',
            amount: 100
          },
          vatPercentage: 10
        },
        discount: {
          discountValue: {
            currency: 'SAR',
            amount: 100
          },
          discountSource: 'Discount',
          discountReferenceId: '1234567890'
        }
      }
    },
    {
      id: '550e8400-e29b-41d4-a716-446655440000',
      createdOnUtc: '2025-02-25T10:00:00Z',
      modifiedOnUtc: '2025-02-25T11:00:00Z',
      createdById: 'a7b8c9d0-e12f-4e3b-97a5-12d34f56789a',
      modifiedById: 'f1e2d3c4-b5a6-47c8-9d0e-11a22b3c4d5e',
      client: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Provider One',
        arabicName: 'العميل الاول'
      },
      project: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      customer: {
        id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        englishName: 'John Doe',
        type: 'Customer',
        subscriptionType: 'B2C'
      },
      parkingArea: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي'
      },
      servicePrice: {
        id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
        englishName: 'Main Center',
        arabicName: 'المركز الرئيسي',
        hourRate: { amount: 10, currency: 'SAR' }
      },
      vehicles: [
        {
          licensePlate: {
            plateLetters: 'AAb',
            plateDigits: '112',
            licensePlateType: {
              id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
              englishName: 'Provider One',
              arabicName: 'العميل الاول'
            }
          },
          make: {
            id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
            englishName: 'Provider One',
            arabicName: 'العميل الاول'
          },
          model: {
            id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
            englishName: 'Provider One',
            arabicName: 'العميل الاول'
          },
          id: 'd9ce027d-fc7a-4545-86aa-c47f499c6b27',
          autoIncrementalId: 0
        }
      ],
      isIntegrationSource: true,
      isSettled: false,
      status: 'AboutToExpire',
      orderId: '3d5672aa-3674-4a24-9bf4-be39cd83e210',
      startTime: '2025-08-09T10:47:19.589',
      endTime: '2025-08-19T10:47:19.589',
      code: 'code1',
      pricing: {
        total: {
          currency: 'SAR',
          amount: 100
        },
        subtotal: {
          currency: 'SAR',
          amount: 100
        },
        vat: {
          vatAmount: {
            currency: 'SAR',
            amount: 100
          },
          vatPercentage: 10
        },
        discount: {
          discountValue: {
            currency: 'SAR',
            amount: 100
          },
          discountSource: 'Discount',
          discountReferenceId: '1234567890'
        }
      }
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 2,
    order: 'Ascending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

const myOnStreetReservationDetailsResponse: any = {
  id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  autoIncrementalId: 1,
  parkingArea: { id: 'c3d4e5f6-a7b8-9012-cdef-345678901234', englishName: 'Zone A', arabicName: 'المنطقة أ' },
  vehicle: {
    id: 'd9ce027d-fc7a-4545-86aa-c47f499c6b27',
    licensePlate: {
      plateLetters: 'AAb',
      plateDigits: '112',
      licensePlateType: {
        id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
        englishName: 'Private',
        arabicName: 'خاص'
      }
    },
    productionYear: 2022,
    accessStatus: 'Active',
    vehicleType: 'Sedan',
    make: {
      id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
      englishName: 'Toyota',
      arabicName: 'تويوتا'
    },
    model: {
      id: 'd2f5b2fc-3c54-45f2-9043-3f22d307b7c1',
      englishName: 'Camry',
      arabicName: 'كامري'
    }
  },
  pricing: {
    subtotal: { amount: 40.00, currency: 'SAR' },
    discount: {
      discountValue: { amount: 0, currency: 'SAR' },
      discountSource: 'None'
    },
    vat: {
      vatAmount: { amount: 6.00, currency: 'SAR' },
      vatPercentage: 15
    },
    total: { amount: 46.00, currency: 'SAR' }
  },
  status: 'Active',
  startTime: '2025-03-20T10:00:00Z',
  endTime: '2025-03-20T12:00:00Z',
  totalHours: 2,
  remainingHours: 1,
  supportsOnlinePayment: true,
  details: [],
  invoices: [
    {
      id: 'f6a7b8c9-d0e1-2345-f678-901234567890',
      autoIncrementalId: 1,
      invoiceNumber: 'INV-2025-001',
      isTaxable: true,
      pricing: {
        subtotal: { amount: 40.00, currency: 'SAR' },
        discount: {
          discountValue: { amount: 0, currency: 'SAR' },
          discountSource: 'None'
        },
        vat: {
          vatAmount: { amount: 6.00, currency: 'SAR' },
          vatPercentage: 15
        },
        total: { amount: 46.00, currency: 'SAR' }
      },
      createdOnUtc: '2025-03-20T12:00:00Z',
      modifiedOnUtc: '2025-03-20T12:00:00Z'
    }
  ]
};

const myInvoicesResponse: IPaginationResponse<ICustomerInvoiceListResponse> = {
  items: [
    {
      id: 'f6a7b8c9-d0e1-2345-f678-901234567890',
      invoiceNumber: 'INV-2025-001',
      orderId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      type: 'TaxInvoice',
      source: 'OnStreet',
      paymentMethod: 'CreditCard',
      vatPercentage: 15,
      isTaxable: true,
      status: 'Paid',
      client: {
        englishName: 'Makani Parking Co.',
        arabicName: 'شركة مكاني لمواقف السيارات',
        crNumber: '1010101010',
        vatNumber: '300000000000003'
      },
      project: {
        englishName: 'Al-Olaya District Parking',
        arabicName: 'مواقف حي العليا'
      },
      pricing: {
        subtotal: { amount: 40.0, currency: 'SAR' },
        vat: {
          vatAmount: { amount: 6.0, currency: 'SAR' },
          vatPercentage: 15
        },
        discount: {
          discountValue: { amount: 0, currency: 'SAR' },
          discountSource: 'None'
        },
        total: { amount: 46.0, currency: 'SAR' }
      },
      createdOnUtc: '2025-03-20T12:00:00Z',
      modifiedOnUtc: '2025-03-20T12:00:00Z'
    },
    {
      id: 'e5d4c3b2-a109-8765-4321-fedcba098765',
      invoiceNumber: 'INV-2025-002',
      orderId: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
      type: 'SimplifiedTaxInvoice',
      source: 'OffStreet',
      paymentMethod: 'ApplePay',
      vatPercentage: 15,
      isTaxable: true,
      status: 'Paid',
      client: {
        englishName: 'Makani Parking Co.',
        arabicName: 'شركة مكاني لمواقف السيارات',
        crNumber: '1010101010',
        vatNumber: '300000000000003'
      },
      project: {
        englishName: 'King Fahd Road Parking',
        arabicName: 'مواقف طريق الملك فهد'
      },
      pricing: {
        subtotal: { amount: 20.0, currency: 'SAR' },
        vat: {
          vatAmount: { amount: 3.0, currency: 'SAR' },
          vatPercentage: 15
        },
        discount: {
          discountValue: { amount: 0, currency: 'SAR' },
          discountSource: 'None'
        },
        total: { amount: 23.0, currency: 'SAR' }
      },
      createdOnUtc: '2025-03-21T15:30:00Z',
      modifiedOnUtc: '2025-03-21T15:30:00Z'
    }
  ],
  paginationMetadata: {
    totalItemCount: 2,
    numberOfPages: 1,
    pageSize: 10,
    order: 'Descending',
    page: 1,
    hasNext: false,
    hasPrevious: false
  }
};

export const customerProfilesData = {
  customerProfilesResponse,
  customerProfileResponse,
  customerEligibleAccountsResponse,
  customerProfilesBaseResponse,
  createCustomerProfileResponse,
  myOnStreetReservationsResponse,
  myOnStreetReservationResponse,
  myOnStreetReservationDetailsResponse,
  myInvoiceByOrderResponse,
  myInvoicesResponse,
  reservationsResponse,
  reservationResponse,
  publicOffStreetReservationResponse
};
